import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { setDataValue, getDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';

const booleanToFloatDef = {
  type: FgBlockType.BooleanToFloat,
  build: () => ({
    dataIn: [sockIn("a", FgType.Boolean, false)],
    dataOut: [sockOut("value", FgType.Number)]
  }),
  updateOutputs(block, ctx, env) {
    setDataValue(ctx, block, "value", getDataValue(ctx, env, block, "a") ? 1 : 0);
  }
};

export { booleanToFloatDef };
//# sourceMappingURL=boolean-to-float.js.map
